import {
  DatePropertyYearPulldown,
  DateYearPulldownInputProps,
  DATE_PROPERTY_UNSELECTED_VALUE_TYPE,
} from 'shared';

export const YEAR_DEFAULT_HYPHEN = '----';
export const MONTH = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
] as const;
export const MONTH_DEFAULT_HYPHEN = '--';
export const MONTH_WITH_DEFAULT = [MONTH_DEFAULT_HYPHEN, ...MONTH];
export const DAY = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
] as const;
export const DAY_DEFAULT_HYPHEN = '--';
export const DAY_WITH_DEFAULT = [DAY_DEFAULT_HYPHEN, ...DAY];
export const DATE_DELIMITER = '-';

// showRangeは実際は必ず入ってくるが、バックエンドの都合上openapiではオプショナルになっているので
// fromとtoの値をフロントでデフォルト値を持っておく
export const YEAR_PULLDOWN_DEFAULT_FROM = 1900;
export const YEAR_PULLDOWN_DEFAULT_TO = new Date().getFullYear() + 5;

type YearPulldownInputFormat = DatePropertyYearPulldown['inputFormat'];

export const getYearItems = (
  showRange: YearPulldownInputFormat['showRange'],
  unselectedState: YearPulldownInputFormat['unselectedState'],
): DateYearPulldownInputProps['yearItems'] => {
  const from = showRange?.showYearFrom ?? YEAR_PULLDOWN_DEFAULT_FROM;
  const to = showRange?.showYearTo ?? YEAR_PULLDOWN_DEFAULT_TO;
  const items = Array.from({ length: to - from + 1 }, (_, i) => {
    const year = `${from + i}`;
    return {
      label: year,
      value: year,
    };
  });

  if (!unselectedState) {
    return items;
  }
  switch (unselectedState.valueType) {
    case DATE_PROPERTY_UNSELECTED_VALUE_TYPE.hyphen:
      return [
        {
          label: YEAR_DEFAULT_HYPHEN,
          value: '',
        },
        ...items,
      ];
  }
};

const monthItems = MONTH.map((month) => ({
  label: month,
  value: month,
}));
const monthItemsWithDefaultHyphen = MONTH_WITH_DEFAULT.map((month) => {
  if (month === MONTH_DEFAULT_HYPHEN) {
    return {
      label: month,
      value: '',
    };
  }
  return {
    label: month,
    value: month,
  };
});

export const getMonthItems = (
  unselectedState: YearPulldownInputFormat['unselectedState'],
): DateYearPulldownInputProps['monthItems'] => {
  if (!unselectedState) {
    return monthItems;
  }
  switch (unselectedState.valueType) {
    case DATE_PROPERTY_UNSELECTED_VALUE_TYPE.hyphen:
      return monthItemsWithDefaultHyphen;
  }
};

const dayItems = DAY.map((day) => ({
  label: day,
  value: day,
}));
const dayItemsWithDefaultHyphen = DAY_WITH_DEFAULT.map((day) => {
  if (day === DAY_DEFAULT_HYPHEN) {
    return {
      label: day,
      value: '',
    };
  }
  return {
    label: day,
    value: day,
  };
});

export const getDayItems = (
  unselectedState: YearPulldownInputFormat['unselectedState'],
): DateYearPulldownInputProps['dayItems'] => {
  if (!unselectedState) {
    return dayItems;
  }
  switch (unselectedState.valueType) {
    case DATE_PROPERTY_UNSELECTED_VALUE_TYPE.hyphen:
      return dayItemsWithDefaultHyphen;
  }
};
